export enum TableStyle {
    DataTable,
    SpreadSheet
}
